import React from 'react';
import { useNavigate } from 'react-router-dom';
import { soundManager } from '../utils/SoundManager';
import knightsFourTrainersData from '../data/KnightsFour';
import './KnightsFour.css';

const KnightsFourTrainers = () => {
    const navigate = useNavigate();

    // Convert trainer data object to array
    const trainers = Object.values(knightsFourTrainersData);

    // Handle trainer selection
    const handleTrainerSelect = (trainer) => {
        console.log('⚔️ Knights Four trainer selected:', trainer.name);

        // 🎵 TRAINER SELECTION SOUND
        soundManager.playButtonSound();

        // Navigate to individual trainer page
        navigate(`/knight-trainer/${trainer.id}`);
    };

    // Handle back navigation
    const handleBackToCategories = () => {
        soundManager.playButtonSound();
        navigate('/knights-train-categories');
    };

    return (
        <div className="knights-four-trainers-container">
            <div className="knights-four-animated-background"></div>

            {/* Back Button */}
            <button
                className="back-to-categories-button knights-four-back"
                onClick={handleBackToCategories}
            >
                ← Back to Categories
            </button>

            {/* Header */}
            <div className="knights-four-trainers-header">
                <div className="header-content">
                    <h1>Exotic & International Knights</h1>
                    <p>Train with warriors from distant lands and diverse backgrounds</p>
                    <div className="category-stats">
                        <span className="stat-badge knights-four-badge">Trainers: {trainers.length}</span>
                        <span className="stat-badge knights-four-badge">Programs: {trainers.length * 6}</span>
                        <span className="stat-badge knights-four-badge">Category: International Knights</span>
                    </div>
                </div>
            </div>

            {/* Trainers Grid */}
            <div className="knights-four-trainers-grid">
                {trainers.map((trainer, index) => (
                    <div
                        key={trainer.id}
                        className="knight-four-trainer-card"
                        onClick={() => handleTrainerSelect(trainer)}
                        style={{
                            '--knight-four-primary-color': trainer.color,
                            '--knight-four-secondary-color': trainer.secondaryColor
                        }}
                    >
                        {/* Trainer Image */}
                        <div className="knight-four-trainer-image-section">
                            <div
                                className="knight-four-trainer-image"
                                style={{
                                    backgroundImage: `url(${trainer.image})`
                                }}
                            >
                                <div className="exotic-gleam-effect"></div>
                                <div className="experience-badge knight-four-badge">
                                    {trainer.experience}
                                </div>
                            </div>
                        </div>

                        {/* Trainer Info */}
                        <div className="knight-four-trainer-info-section">
                            <h3 className="knight-four-trainer-name">{trainer.name}</h3>
                            <h4 className="knight-four-trainer-title">{trainer.title}</h4>
                            <p className="knight-four-trainer-specialization">{trainer.specialization}</p>
                            <p className="knight-four-trainer-description">{trainer.intro}</p>

                            <div className="knight-four-trainer-details">
                                <div className="detail-item knight-four-detail">
                                    <div className="detail-icon">🌍</div>
                                    <div className="detail-text">Programs: {trainer.programs.length}</div>
                                </div>
                                <div className="detail-item knight-four-detail">
                                    <div className="detail-icon">⚡</div>
                                    <div className="detail-text">{trainer.experience}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Footer */}
            <div className="knights-four-trainers-footer">
                <div className="knights-four-info">
                    <h3>International Knights Philosophy</h3>
                    <div className="knights-four-benefits-grid">
                        <div className="knight-four-benefit-item">
                            <div className="benefit-icon">🏆</div>
                            <div>
                                <strong>Merit-Based Excellence</strong>
                                <p>Proving-ground conditioning that earns honor through achievement</p>
                            </div>
                        </div>
                        <div className="knight-four-benefit-item">
                            <div className="benefit-icon">🌟</div>
                            <div>
                                <strong>Cultural Fusion</strong>
                                <p>Eastern and Western combat techniques blended into superior methods</p>
                            </div>
                        </div>
                        <div className="knight-four-benefit-item">
                            <div className="benefit-icon">🐺</div>
                            <div>
                                <strong>Wild Strength</strong>
                                <p>Primitive conditioning that rejects civilized weakness</p>
                            </div>
                        </div>
                        <div className="knight-four-benefit-item">
                            <div className="benefit-icon">⚡</div>
                            <div>
                                <strong>Fearless Courage</strong>
                                <p>Bold training that transforms fear into devastating action</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default KnightsFourTrainers;